import ApiClient from '@/api/ApiClient';

const client = new ApiClient('googlemap');

class GoogleMapApi {

	static get (params: ICreateGoogleMapModel) {
		return client.get<string>(``, { params });
	}

}

export default GoogleMapApi;
